import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';

export default function DialogHeader({ icon, title, subtitle, onClose }) {
  const theme = useTheme();
  return (
    <Box sx={{
      background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
      px: 3,
      py: 2.5,
      display: 'flex',
      alignItems: 'center',
      gap: 2,
    }}>
      <Box sx={{
        width: 44,
        height: 44,
        borderRadius: '12px',
        bgcolor: alpha('#fff', 0.15),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}>
        {React.cloneElement(icon, { sx: { color: '#fff', fontSize: 22 } })}
      </Box>
      <Box sx={{ flexGrow: 1, minWidth: 0 }}>
        <Typography variant="h6" sx={{ color: '#fff', lineHeight: 1.2 }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="caption" sx={{ color: alpha('#fff', 0.7) }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {onClose && (
        <IconButton onClick={onClose} size="small" sx={{ color: alpha('#fff', 0.8), '&:hover': { color: '#fff', bgcolor: alpha('#fff', 0.1) } }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
}
